export default {
    account: {
        singular: 'account',
    },
    divisions: {
        general: 'general',
    },
    civility: {
        singular: 'civility',
    },
    delivery: {
        singular: 'delivery',
        plural: 'deliveries',
    },
    deliverable: {
        singular: 'deliverable',
    },
    delivered: {
        infinitive: 'to deliver',
        singular: 'delivered',
        plural: 'delivered',
        feminineSingular: 'delivered',
        femininePlural: 'delivered',
    },
    deliveryDate: {
        singular: 'delivery date',
    },
    loyalty: {
        singular: 'loyalty',
    },
    dashboard_columns: {
        presented: 'visit',
    },
    presented: {
        singular: 'visit',
    },
    presentedOther: {
        singular: 'other visit',
    },
    province: {
        CA: 'province',
    },
    portfolio: {
        singular: 'portfolio',
        plural: 'portfolios',
        prefix: 'a portfolio',
        abr: 'portfolio',
    },
    renewal: {
        singular: 'renewal',
        plural: 'renewals',
    },
    renewed: {
        infinitive: 'renew',
        singular: 'renewed',
        plural: 'renewed',
    },
    result: {
        singular: 'result',
    },
    sale: {
        singular: 'sale',
        plural: 'sales',
        prefix: 'a sale',
    },
    secondaryAdvisor: {
        singular: 'second associate',
    },
    sold: {
        singular: 'sold',
        plural: 'sold',
    },
    undelivered: {
        singular: 'undelivered',
        plural: 'undelivered',
    },
    version: {
        singular: 'trim',
    },
    walkIn: {
        singular: 'walk-in',
        plural: 'walk-in',
        prefix: 'a walk-in',
        abr: 'walk-in',
    },
    certified: 'Certified',
};
